module.exports = __webpack_public_path__ + "img/Montenegro.b8846f08.gif";